export default __webpack_public_path__ + "static/media/Punto_11_Palazzi_dell_800_SPA_Def.7aeaf542.aac";